import {Persona} from './persona.model';
import {DetailField} from '../../../shared/models';

export const PERSONASCOREDETAIL_DEFAULT_FIELDS: DetailField[] = [
  { name: 'personaNombre', label: 'Nombre y Apellidos' },
  { name: 'personaCedula', label: 'Cédula' },
  // { name: 'personaPrimerApellido', label: 'Primer Apellido' },
  // {
  //   name: 'personaFechaDeNacimiento',
  //   label: 'Fecha de Nacimiento',
  //   format: formatDate
  // }
];

export interface PersonasCoreDetailParams {
  persona: Persona;
  fields?: DetailField[];
}
